import React, { useState } from "react";
import "./SignUp.css";
import backgroundImage from "./background.png";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const SignUp = () => {

    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        password: "",
        confirmPassword: "",
        affiliatedOrg: "",
    });

    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    //validate format
    const validateEmail = (email) => {
        const emailRegex = /^.+@.+\..+$/;
        return emailRegex.test(email);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validate email 
        if (!validateEmail(formData.email)) {
            setError("Invalid email format");
            return;
        }

        // Validate passwords match
        if (formData.password !== formData.confirmPassword) {
            
            setError("Passwords do not match");
            return;
        }

        setLoading(true);
        setError(null);

        try {
            const response = await axios.post("/api/userflow/register", {
                email: formData.email,
                password: formData.password,
                first_name: formData.firstName,
                last_name: formData.lastName,
                phone_number: formData.phoneNumber,
                affiliated_org: formData.affiliatedOrg,
            });

            alert("User registered successfully!");
            navigate("/", { replace: true });

        }
        catch (err) {
            setError(err.response?.data?.message || "Error registering user");
        }

}

    return (
        <div className="login-container" style={{ backgroundImage: `url(${backgroundImage})` }}>
            <div className="overlay"></div>
            <div className="content">
                <div className="branding">
                    <h1 className="main-text">
                        uTECH <span className="overlay-text">Mobility Analyzer</span>
                    </h1>
                </div>
                <form className="login-box" onSubmit={handleSubmit}>
                    <input type="text" name="firstName" placeholder="First Name" value={formData.firstName} onChange={handleChange} required />
                    <input type="text" name="lastName" placeholder="Last Name" value={formData.lastName} onChange={handleChange} required />
                    {error === "Invalid email format" && <p className="error-message">{error}</p>}
                    <input type="text" name="email" placeholder="Email" value={formData.email} onChange={handleChange} required />
                    <input type="text" name="phoneNumber" placeholder="Phone Number" value={formData.phoneNumber} onChange={handleChange}/>
                    <input type="password" name="password" placeholder="Password" value={formData.password} onChange={handleChange} required/>
                    {error === "Passwords do not match" && <p className="error-message">{error}</p>}
                    <input type="password" name="confirmPassword" placeholder="Confirm Password" value={formData.confirmPassword} onChange={handleChange} required />
                    <input type="text" name="affiliatedOrg" placeholder="Affiliated Organization (optional)" value={formData.affiliatedOrg} onChange={handleChange} />
                    <button type="submit" className="login-button">Sign Up</button>

                    <div className="divider">OR</div>
                    <p className="signup">Already have an account?
                        <span onClick={() => navigate("/", { replace: true })}> Sign In</span></p>
                </form>
            </div>
        </div>
    );
};

export default SignUp;
